// extracted by mini-css-extract-plugin
module.exports = {"sp-175w-D":"D_sp-175w-D__0bFsP"};